/** The services' shapes, as this feature uses them: names for the generated types. */
import type { components as Auth } from "@/shared/api/auth.schema";
import type { components as Order } from "@/shared/api/order.schema";

type AuthSchemas = Auth["schemas"];
type OrderSchemas = Order["schemas"];

/** A person's account, as hg-auth shows it to staff. */
export type Account = AuthSchemas["AdminUserResponse"];
export type AccountStatus = AuthSchemas["UserStatus"];
export type UserRole = AuthSchemas["UserRole"];
export type BlockReason = AuthSchemas["BlockReason"];
/** A device the person is signed in on. */
export type Session = AuthSchemas["SessionResponse"];
export type UpdateMe = AuthSchemas["UpdateMeRequest"];
export type Language = AuthSchemas["Language"];

/** The languages an account may have: SMS and notifications come in it. */
export const ACCOUNT_LANGUAGES = [
  "uz",
  "uz-Cyrl",
  "kaa",
  "ru",
  "en",
] as const satisfies readonly Language[];
/** One line of the sign-in history. */
export type AuthEvent = AuthSchemas["AuthEventResponse"];
/** A blocked number: masked, the number itself is not kept. */
export type PhoneBlock = AuthSchemas["PhoneBlockResponse"];
/** The account behind a phone, as much of it as taking an order needs. */
export type FoundClient = AuthSchemas["FoundClientResponse"];
/** How far a deleted account's erasure has come. */
export type Erasure = AuthSchemas["ErasureResponse"];

/** What hg-order knows of a client: who they order for, where to, what is under way. */
export type ClientCard = OrderSchemas["ClientCardResponse"];
export type ClientAddress = OrderSchemas["AddressResponse"];
export type ClientPatient = OrderSchemas["PatientResponse"];
export type OrderRow = OrderSchemas["StaffOrderRowResponse"];
/** What a client's orders add up to. */
export type ClientSummary = OrderSchemas["ClientSummaryResponse"];

export const ACCOUNT_STATUSES = [
  "active",
  "blocked",
  "deleted",
] as const satisfies readonly AccountStatus[];

/** Why an account or a number is blocked, as hg-auth lists the reasons. */
export const BLOCK_REASONS = [
  "fraud",
  "abuse",
  "spam",
  "duplicate_account",
  "legal",
  "other",
] as const satisfies readonly BlockReason[];

/** The staff roles, the one with the most power first. */
export const STAFF_ROLES = [
  "superadmin",
  "admin",
  "dispatcher",
] as const satisfies readonly UserRole[];
export type StaffRole = (typeof STAFF_ROLES)[number];

/** The orders a list of accounts can be read in, as hg-auth names them. */
export const SORTS = ["-created_at", "created_at", "full_name", "-full_name"] as const;
export type Sort = (typeof SORTS)[number];
